import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'pa-chip',
  standalone: true,
  imports: [ChipModule, TooltipModule, NgIf],
  templateUrl: './pa-chip.component.html',
  styleUrls: ['./pa-chip.component.scss'],
})
export class PaChipComponent {
  @Input() label: string;
  @Input() maxLabelLength: number | null = null;
  @Input() icon: string;
  @Input() image: string;
  @Input() removable = false;
  @Input() styleClass: string;
  @Input() style: { [key: string]: string };

  @Output() remove = new EventEmitter<void>();
  @Output() chipClick = new EventEmitter<void>();

  get hasBuiltInContent(): boolean {
    return !!(this.icon || this.image);
  }

  get displayLabel(): string {
    if (!this.label) {
      return '';
    }

    if (!this.maxLabelLength || this.label.length <= this.maxLabelLength) {
      return this.label;
    }

    return `${this.label.slice(0, this.maxLabelLength)}...`;
  }

  get isTruncated(): boolean {
    return !!this.label && !!this.maxLabelLength && this.label.length > this.maxLabelLength;
  }

  onLabelClick(event: MouseEvent): void {
    event.stopPropagation();
    this.chipClick.emit();
  }

  onRemoveClick(event?: MouseEvent): void {
    if (event) {
      event.stopPropagation();
    }
    this.remove.emit();
  }
}
